import { type NamespaceStore } from "./createNamespaceStore";

type BaseStore = NamespaceStore<
  { lastEventAt: null | number; lastListenerError: null | string },
  unknown
>;

/**
 * Produce a plain mutation options object (v4-compatible) that handles the
 * boilerplate every namespace share: ensure the store is initialized so event
 * callbacks are registered before any mutation runs.
 *
 * The `run` callback is where each mutation does its side-effect work
 * (calling into qz-tray and then mutating local state). It can safely throw;
 * the helper intentionally leaves error state to react-query so namespace
 * stores only report listener/callback failures.
 */
export const createNamespaceMutation = <TInput = void, TResult = void>(config: {
  key: readonly unknown[];
  run: (input: TInput) => Promise<TResult>;
  store: Pick<BaseStore, "ensureInitialized">;
}) => ({
  mutationFn: async (input: TInput): Promise<TResult> => {
    config.store.ensureInitialized();
    return config.run(input);
  },
  mutationKey: [...config.key],
});
